export const calloutClassificationColor = (classification: string) => {
    if (!classification) return 'yellow';
    switch (classification) {
        case 'test':
            return 'red';
        case 'real':
            return 'green';
    }
}